var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVenderPorDia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 84"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 62",
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#FFD8D8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "coleta icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gota",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1892 34.113L29.9576 32.0603L29.4911 31.2828L29.0246 32.0603L27.793 34.113L27.6493 34.4183C27.014 35.7684 27.999 37.3206 29.4911 37.3206C30.9832 37.3206 31.9682 35.7684 31.3329 34.4183L31.1892 34.113ZM29.4911 32.8378L28.4997 34.4901L28.3732 34.759C27.9875 35.5784 28.5854 36.5206 29.4911 36.5206C30.3968 36.5206 30.9947 35.5784 30.609 34.759L30.4825 34.4901L29.4911 32.8378Z",
    fill: "#D91F05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 315",
    d: "M20.707 20C20.707 19.1716 21.3786 18.5 22.207 18.5H36.3202C37.1487 18.5 37.8202 19.1716 37.8202 20V41.6509H20.707V20Z",
    stroke: "#D91F05"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 316",
    x: 23.7266,
    y: 22.1226,
    width: 11.0755,
    height: 5.03774,
    rx: 1,
    stroke: "#D91F05"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 317",
    x: 19.5,
    y: 41.4434,
    width: 19.5283,
    height: 3.83019,
    rx: 1.91509,
    stroke: "#D91F05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M43.0469 30.4906L43.0469 26.0157L44.3967 24.2159L50.4997 30.8737V31.9906H44.5469C43.7185 31.9906 43.0469 31.319 43.0469 30.4906Z",
    stroke: "#D91F05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M37.5 36.1132H40.5472C41.6518 36.1132 42.5472 37.0086 42.5472 38.1132V39.7358C42.5472 42.07 44.4395 43.9623 46.7737 43.9623V43.9623V43.9623C48.7744 43.9623 50.3963 42.3403 50.3963 40.3396V31.8868",
    stroke: "#D91F05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 320",
    d: "M43.1314 26.0354L39.6158 23.4973C39.1163 23.1366 39.0037 22.4393 39.3644 21.9398C39.725 21.4402 40.4223 21.3277 40.9218 21.6883L44.4374 24.2264L43.1314 26.0354Z",
    stroke: "#D91F05"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenderPorDia);
export default __webpack_public_path__ + "static/media/venderPorDia.a4e210819bac4d50fd72114be7721700.svg";
export { ForwardRef as ReactComponent };